(function () {
  'use strict';

  // never touch the cart page
  if (location.pathname.indexOf('/cart') === 0) return;

  function sel(root, q) { return (root || document).querySelector(q); }

  function refreshMiniCartDOM() {
    fetch('/?sections=mini_cart', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.mini_cart) return;

        // Parse returned mini_cart HTML
        var temp = document.createElement('div');
        temp.innerHTML = data.mini_cart;

        var freshItems  = sel(temp, '[data-cart-items]');
        var freshBottom = sel(temp, '.t4s-drawer__bottom');

        // LIVE targets (these exist on your site; we update only inner content)
        var liveItems = sel(document, '#t4s-mini_cart [data-cart-items], [data-cart-wrapper] [data-cart-items], .t4s-mini_cart [data-cart-items], [data-cart-items]');
        var liveBottom = sel(document, '#t4s-mini_cart .t4s-drawer__bottom, [data-cart-wrapper] .t4s-drawer__bottom, .t4s-mini_cart .t4s-drawer__bottom, .t4s-drawer__bottom');

        if (freshItems && liveItems) liveItems.innerHTML = freshItems.innerHTML;
        if (freshBottom && liveBottom) {
          liveBottom.innerHTML = freshBottom.innerHTML;

          // FIRST-OPEN FIX: make bottom immediately clickable (kills "dead" buttons)
          liveBottom.style.opacity = '1';
          liveBottom.style.transform = 'translateY(0)';
          liveBottom.style.pointerEvents = 'auto';
          liveBottom.style.visibility = 'visible';
        }
      })
      .catch(function(){ /* no-op */ });
  }

  // After add-to-cart button clicks, refresh shortly after drawer opens
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[name="add"], button[type="submit"], .t4s-btn-atc, .t4s-pr-addtocart, [data-atc], .t4s-btn__addtocart'
    );
    if (!btn) return;

    // don’t interfere with clicks inside the drawer itself
    if (btn.closest('#t4s-mini_cart, [data-cart-wrapper], .t4s-mini_cart')) return;

    // two passes: quick + safety
    setTimeout(refreshMiniCartDOM, 250);
    setTimeout(refreshMiniCartDOM, 800);
  }, true);

  // When clicking the HEADER cart icon / drawer-open triggers, refresh once
  document.addEventListener('click', function (e) {
    // IMPORTANT: do NOT match a[href="/cart"] because View Cart uses that and must remain clickable
    var trigger = e.target.closest('[data-drawer-open], .t4s-site-nav__cart a');
    if (!trigger) return;

    // ignore clicks inside drawer so we never touch View Cart / Checkout clicks
    if (trigger.closest('#t4s-mini_cart, [data-cart-wrapper], .t4s-mini_cart')) return;

    setTimeout(refreshMiniCartDOM, 250);
  }, true);

  // Also refresh when quantity changes inside drawer (keeps subtotal/buttons in sync)
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp) return;
    if (!inp.matches('input[name="updates[]"], .t4s-quantity-input, [data-quantity-value]')) return;
    if (!inp.closest('#t4s-mini_cart, [data-cart-wrapper], .t4s-mini_cart')) return;

    setTimeout(refreshMiniCartDOM, 250);
  }, true);

})();
